<mat-toolbar>
   <div class="flex flex--justify-between w-100">
      <div class="flex flex--align-center">
         <span *ngIf="environment.stage" class="top-left-corner-label">Stage</span>

         <button
            mat-icon-button
            aria-label="Menu icon"
            class="me-1"
            [class.ms-5]="environment.stage"
            (click)="toggleMenu()"
         >
            <mat-icon>menu</mat-icon>
         </button>

         <a routerLink="/" class="d-none d-sm-block logo">
            <img alt="logo" *ngIf="user$ | async as user" [src]="user.company.settings.logoUrl" />
         </a>
      </div>

      <div class="topbar-template">
         <ng-container *ngIf="topbarTemplate$ | async as template">
            <ng-container *ngTemplateOutlet="template"></ng-container>
         </ng-container>
      </div>

      <div *ngIf="user$ | async as user" class="flex flex--align-center" [matMenuTriggerFor]="menu">
         <p class="fs-18 m-0 d-none d-sm-block">{{ user?.username }}</p>
         <div class="avatar ms-2">
            {{ userInitials$ | async }}
         </div>
      </div>

      <mat-menu #menu="matMenu">
         <button mat-menu-item *hasAuthorities="Authority.ViewCashRegister" (click)="openLocalCashRegisterSettings()">
            Cash Register Settings
         </button>

         <button mat-menu-item (click)="onLogout()">Log out</button>
      </mat-menu>
   </div>
</mat-toolbar>
<mat-sidenav-container autosize="true">
   <mat-sidenav
      [ngClass]="!isCollapsed ? 'expanded' : ''"
      [mode]="isMobile ? 'over' : 'side'"
      [opened]="isMobile ? 'false' : 'true'"
   >
      <app-side-bar [list]="list" [isCollapsed]="isCollapsed"></app-side-bar>
   </mat-sidenav>
   <mat-sidenav-content>
      <div class="scrollable">
         <router-outlet></router-outlet>
      </div>
   </mat-sidenav-content>
</mat-sidenav-container>
